(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["le-core-sidemenu-left"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const mainMenuView = document.querySelector('.main-menu-view');
  const subcategoryViews = document.querySelectorAll('.subcategory-view');
  const categoryHeaders = document.querySelectorAll('.category-header');
  const backButtons = document.querySelectorAll('.back-btn');
  const setNavHeight = () => {
    const sidemenuNav = document.querySelector('.sidemenu_nav_main');
    const mainMenuHeight = mainMenuView.scrollHeight;
        let maxSubcategoryHeight = 0;
    subcategoryViews.forEach(view => {
      if (view.scrollHeight > maxSubcategoryHeight) {
        maxSubcategoryHeight = view.scrollHeight;
      }
    });
    
    const minHeight = Math.max(mainMenuHeight, maxSubcategoryHeight);
    sidemenuNav.style.minHeight = minHeight + 'px';
  };
  
  setNavHeight();
  window.addEventListener('resize', setNavHeight);

  // Show subcategory menu
  categoryHeaders.forEach(header => {
    const category = header.closest('.nav-category');
    if (category) {
      const categoryId = category.dataset.category;
      const subcategoryView = document.querySelector(`.subcategory-view[data-view="${categoryId}"]`);
      
      if (subcategoryView) {
        header.addEventListener('click', function(e) {
          if (e.target.tagName === 'A') return;
          
          // Forced animation
          void mainMenuView.offsetWidth;
          
          subcategoryView.classList.add('active');
          
          setTimeout(() => {
            mainMenuView.classList.remove('active');
          }, 50);
        });
      }
    }
  });

  // Back button
  backButtons.forEach(button => {
    button.addEventListener('click', function() {
      const subcategoryView = this.closest('.subcategory-view');
      
      void subcategoryView.offsetWidth;
      
      mainMenuView.classList.add('active');
      
      setTimeout(() => {
        subcategoryView.classList.remove('active');
      }, 50);
    });
  });

  // Highlight
  const currentPath = window.location.pathname;
  const allLinks = document.querySelectorAll('.submenu a');

  allLinks.forEach(link => {
    if (link.getAttribute('href') === currentPath) {
      const subcategoryView = link.closest('.subcategory-view');
      if (subcategoryView) {
        const categoryId = subcategoryView.dataset.view;
        const categoryElement = document.querySelector(`.nav-category[data-category="${categoryId}"]`);
        if (categoryElement) {
          categoryElement.classList.add('current');
        }
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-main-article-seo-barbie"]) return;
  try {
    
$('.sliderseo').each(function() {
  $(this).find('.slickcarousel').slick({
    autoplay:true,
    slidesToShow:4,
    slidesToScroll:4,
    arrows: false,
    dots:true,
    appendDots:$(this).find('.slickdotposition'),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow:2,
          slidesToScroll:2
        }
      }
    ]
  });
})
  
$('.expandlist').click(function(e) {
  e.preventDefault();
  $(this).parent().toggleClass('openlist');
})

$('.opensteps').click(function(e) {
  e.preventDefault();
  $(this).closest(".get-the-look").children('.listcheck').toggleClass('openlist');
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-main-product"]) return;
  try {
    
  $("[data-load-block]").click(function(){
    var target = $(this).data("load-block");
    $( ".extrapdpblocks section" ).not("#"+target).removeClass("selected");
    $("#"+target).toggleClass("selected");
  });

  $(window).on('load', function () {
    if ($(window).width() < 700) {
      $('.pdpimages .carousel').slick({
        autoplay:true,
        arrows:false,
        slidesToShow:1,
        dots:true,
        centerMode:false,
      });
      $('.pdpimages .carousel').show();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-announcement-rollaway"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function($) {
    $('.announcements').slick({
      autoplay:true,
      autoplaySpeed:4000,
      arrows:false,
      dots:false,
      infinite:true
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-announcement-static"]) return;
  try {
    
  $(document).ready(function($) {
    $('.announcements').slick({
      autoplay:true,
      autoplaySpeed:4000,
      arrows:false,
      dots:false,
      infinite:true
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-cursor"] && !window.DesignMode) return;
  try {
    
  $(document).on("mousemove", function(e) {
    $("#topsecretcursor").css({
      left: e.pageX + 15,
      top: e.pageY + 12
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-find-your-shade"] && !window.DesignMode) return;
  try {
    
  $('.shadeslider').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    centerMode: true,
    responsive: [
    {
      breakpoint: 640,
      settings: {
      slidesToShow:3,
    }
    }]
  });
  $(".shadeslider").show();

  // Slide to shade when swatch is clicked
  $('a[data-slick-index]').on('click', function () {
    var slideno = $(this).data('slick-index');
    $('.shadeslider').slick('slickGoTo', slideno);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-flexible-panel-row"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const revealElements = document.querySelectorAll('.reveal');

    revealElements.forEach(function(reveal) {
      const primaryImage = reveal.querySelector('.primary-image');
      const hoverImage = reveal.querySelector('.hover-image');

      if (hoverImage) {
        primaryImage.classList.add('has-hover');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-latest-portfolio"] && !window.DesignMode) return;
  try {
    
  var firstslide = 0;

      var thisslider = ".latestportfolio .slickcarousel";

        $(thisslider).slick({
          	autoplay:true,
            autoplaySpeed:1500,
          	centerMode:true,
            arrows:false,
            dots:false,
    	  	initialSlide: firstslide,
          	slidesToShow: 3,
    		variableWidth: true,
            prevArrow: $('.latestportfolio .slickprevious'),
            nextArrow: $('.latestportfolio .slicknext'),
            appendDots:$('.latestportfolio .slickdotsposition'),
          	responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                centerMode: true,
    			initialSlide: firstslide,
                slidesToShow: 3
              }
            },
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                centerMode: true,
    			initialSlide: firstslide,
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                centerMode: true,
    			initialSlide: firstslide,
                slidesToShow: 2
              }
            }
          ]
        });

    	$(thisslider).show();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-product-category-grid"] && !window.DesignMode) return;
  try {
    
  $('.filtertabsnav a').click(function(e) {
    $('.stacked-collection').hide();
    $('.filtertabsnav a').removeClass('highlight');

    var filtertag = $(this).data('filtertag');
    $('.' + filtertag).show();
    $(this).addClass('highlight');
  });

  $('.toggle-shades').click(function(e) {
    e.preventDefault();
    $(this).closest('.shades-container').toggleClass('showall');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-product-filters-eyeshadow-refills"] && !window.DesignMode) return;
  try {
    
  $(".product-item-filter a").click(function(e){
    // e.preventDefault();
    $(".product-item-filter a").removeClass("selected-filter");
    $(this).addClass("selected-filter");
    $(".product-item").hide();
    var target = $(this).data("tag");
    $("."+target).show();

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-related-products"] && !window.DesignMode) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=le-module-related-products&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    // alert(requestUrl);
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-sub-navigation"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function($) {

    $('a[data-filtertag]').click(function(e) {

      $('.stacked-collection').hide();
      $('a[data-filtertag]').removeClass('highlight');

      var filtertag = $(this).data('filtertag');
      $('.'+filtertag).show();
      $(this).addClass('highlight');
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-table"] && !window.DesignMode) return;
  try {
    
  $('button.toggle-table-btn, .close-table-link').click(function(){
    var closest = $(this).closest('.le-module-table').attr('id');
    $("#"+closest+" .table-wrapper").toggleClass("hidden");
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-popup-currency"]) return;
  try {
    
$('#localization_submit').remove();
$('#countrydropdown').on('change', function() {
  document.forms['localization_form'].submit();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-temp-pp-find-your-shade"] && !window.DesignMode) return;
  try {
    
  $('.shadeslider').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    centerMode: true,
    responsive: [
    {
      breakpoint: 640,
      settings: {
      slidesToShow:3,
    }
    }]
  });
  $(".shadeslider").show();

  // Slide to shade when swatch is clicked
  $('a[data-slick-index]').on('click', function () {
    var slideno = $(this).data('slick-index');
    $('.shadeslider').slick('slickGoTo', slideno);
  });

  } catch(e) { console.error(e); }
})();
})();
